<template>
<div class="container" ref="findSitters">
    <div class="container remove-margins" >
        <h3 style="margin-top:5px;margin-bottom:5px"> <a  href="javascript:;" @click="goHome()">Home ></a> <a style="text-decoration:none">Search Sitters</a></h3>
    </div>
    <div class="container" >
        <!--<div class="alert h4 alert-info alert-dismissible" role="alert" v-if="!emailConfirmed" >
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                   </button>
             Please confirm your email or phone number from 
            <a href="javascript:;" @click="goAccount()" class="alert-link alert-info"> Account Settings </a> to ensure we can reach you.
        </div>!-->
        <div class="row">
            <div class="col-sm-4 hidden-xs hidden-sm"  style="margin-left:0px;padding-left:0px; margin-right:0px; padding-right:0px">
                <div class="filters" @click="cleanAnchor()">
                    <h5><i class="fa fa-cog" /> Filters and Preferences</h5>
                    <hr>
                    <div class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="citiesList" name="citySelect" class="form-control " v-model="queryDataComp.cityId">
                                  <option value="null" disabled selected hidden>{{selectCityStatusComp}}</option>
                                  <option v-for="city in citiesList" v-bind:value="city.CityId">
                                    {{city.CityName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                    </div>
                  <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="servicesList" name="serviceSelect" class="form-control " v-model="queryDataComp.serviceType">
                                  <option value="null" disabled selected hidden>Choose your Service</option>
                                  <option v-for="service in servicesList" v-bind:value="service.ServiceType">
                                    {{service.ServiceName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                        
                    <div  class="form-from-date">
                        <div class="form-group">
                            <div class='input-group date' id='findSittersDatePickerFrom'>
                             
                             <input v-model="queryDataComp.start" class="form-control input-text" placeholder="Pick up" readonly="true"/>
                                <span class="input-group-addon">
                          <span class="fa fa-calendar"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div  class="form-to-date">
                        <div class="form-group">
                            <div class='input-group date' id='findSittersDatePickerTo'>
                                
                                <input v-model="queryDataComp.end" class="form-control input-text" placeholder="Drop off" :disabled="!queryDataComp.start" readonly="true"/>
                                <span class="input-group-addon">
                          <span class="fa fa-calendar"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    
                       <div v-show="queryDataComp.serviceType==6" class="form-location">
                        <hr>
                        <p style="margin-left:10px;">Dog walking for specific days</p>
                            <label style="margin-left:10px;" class="small checkbox-inline" >
                                <input type="checkbox"  v-model="sun" true-value=1  false-value=0><span class="small">Sun</span>
                            </label>
                            <label class="small checkbox-inline" >
                                <input type="checkbox"  v-model="mon" true-value=2  false-value=0><span class="small">Mon</span>
                            </label>
                                    
                            <label class="small checkbox-inline" >
                                <input type="checkbox"  v-model="tue" true-value=4  false-value=0><span class="small">Tue</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="wed" true-value=8  false-value=0><span class="small">Wed</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="thu" true-value=16  false-value=0><span class="small">Thu</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="fri" true-value=32  false-value=0><span class="small">Fri</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="sat" true-value=64  false-value=0><span class="small">Sat</span>
                            </label>
                            <hr>
                     </div>
                      <div v-show="queryDataComp.serviceType!=6" class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="homeTypesList" name="socialSelect" class="form-control " v-model="queryDataComp.homeType">
                                  <option value="null" disabled selected hidden>Social Preference</option>
                                  <option v-for="home in homeTypesList" v-bind:value="home.HomeType">
                                    {{home.HomeTypeName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                           
                    </div>
                      <div v-show="queryDataComp.serviceType!=6" class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="petprefsList" name="petprefSelect" class="form-control " v-model="queryDataComp.petpref">
                                  <option value="null" disabled selected hidden>Pet Preference</option>
                                  <option v-for="pet in petprefsList" v-bind:value="pet.PetPref">
                                    {{pet.PetPrefName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                             <div class="form-location">
                        <div class="form-group" v-if="filteredAreasList && filteredAreasList.length>0">
                            <div class='form-group ' v-if="filteredAreasList && filteredAreasList.length>0">
                        
                                <select name="areaSelect" class="form-control" v-model="queryDataComp.areaId">
                  <option value="null" disabled selected hidden>Available Neighbors</option>
                  <option v-for="area in filteredAreasList" v-bind:value="area.AreaId">
                    {{area.AreaName}}
                  </option>
                </select>
             
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- <div class="form-group">
                
                        <select class="form-control input-text" placeholder="Filter on price" v-model="queryDataComp.priceRange">
                  <option v-for="price in priceList" v-bind:value="price.priceRange">
                    {{price.label}}
                  </option>
                </select>
                
                    </div> -->
                    <!-- <div role="group">
                        <a class="btn btn-default btn-block btn-sm"  v-model="queryDataComp.petpref" @click="updatePetPref(0)" v-bind:class="{active: queryDataComp.petpref==0}">
                            <img src="./Sitters/images/DogIcon.png" height="25"></img> <span class="button-text">Dog Sitting</span> </a>

                        <a class="btn btn-default btn-block btn-sm"  v-model="queryDataComp.petpref" @click="updatePetPref(1)" v-bind:class="{active: queryDataComp.petpref==1}">
                            <img src="./Sitters/images/CatIcon.png" height="25"></img><span class="button-text">Cat Sitting</span></a>

                        
                    </div> -->
                    <div style="margin-top:10px;">
                    <button  class="btn btn-info btn-block btn-title" @click="resetFilters()">Reset Filters</button>
                    </div>
                </div>
            </div>
            <button @click="cleanAnchor()" class=" hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title" data-toggle="collapse" data-target="#filters"> <i class="fa fa fa-navicon" /> &nbsp Filters and Preferences</button>
             <div class="hidden-xs hidden-sm">
                <div  class="col-sm-8" >
                <h4 style="margin-top:0px;margin-bottom:0px; padding:5px;display:inline-block"><strong>Sory by:</strong></h4>

                                 
                <a  @click="sortList(0)"  v-bind:class="{'strong-font':isCurrentSort(0) }" href="javascript:;"  style="margin-top:0px;font-size:smaller; padding-right:5px;display:inline-block">Recommended</a>
                <a @click="sortList(3)"  v-bind:class="{'strong-font':isCurrentSort(3) }" href="javascript:;" style="margin-top:0px;font-size:smaller;  padding-left:5px; padding-right:5px;display:inline-block">Reviews</a>
                <a @click="sortList(1)"    v-bind:class="{'strong-font':isCurrentSort(1) }" href="javascript:;"  style="margin-top:0px;font-size:smaller;  padding-left:5px; padding-right:5px;display:inline-block">Lowest Price</a>
                <a @click="sortList(2)"    v-bind:class="{'strong-font':isCurrentSort(2) }" href="javascript:;"  style="margin-top:0px;font-size:smaller;  padding-left:5px; padding-right:5px;display:inline-block">Highest Price</a>
                <a @click="sortList(4)"    v-bind:class="{'strong-font':isCurrentSort(4) }" href="javascript:;"  style="margin-top:0px;font-size:smaller;  padding-left:5px; padding-right:5px;display:inline-block">Fastest Response</a>
                
                
                <hr style="margin-top:0px;">
                </div>
            </div>
            <div class="col-sm-12  hidden-md hidden-lg collapse" id="filters" style="margin-left:0px;padding-left:0px; margin-right:0px; padding-right:0px">

                <hr style="margin-top:9px;margin-bottom:9px;">
                <div class="filters">
                    <div class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                       
                                <select required v-if="citiesList" name="citySelect" class="form-control input-text" v-model="queryDataComp.cityId">
                                  <option value="null" disabled selected hidden>{{selectCityStatusComp}}</option>
                                  <option v-for="city in citiesList" v-bind:value="city.CityId">
                                    {{city.CityName}}
                                  </option>
                                </select>
                       
                            </div>
                        </div>
                    </div>
                     <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="servicesList" name="serviceSelect" class="form-control " v-model="queryDataComp.serviceType">
                                  <option value="null" disabled selected hidden>Choose your Service</option>
                                  <option v-for="service in servicesList" v-bind:value="service.ServiceType">
                                    {{service.ServiceName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                    <div  class="form-from-date">
                        <div class="form-group">
                            <div class='input-group date' id='findSittersDatePickerFromMobile'>
                                <!--<input v-model="queryDataComp.start" class="form-control input-text" readonly="true" placeholder="Pick up" />-->
                                <label type='text' readonly="true" v-model="queryDataComp.start" class="form-control input-text" >{{startDateMobileComp}}</label>
                                <span class="input-group-addon">
                          <span class="fa fa-calendar"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div  class="form-to-date">
                        <div class="form-group">
                            <div class='input-group date' id='findSittersDatePickerToMobile'>
                                <label type='text' readonly="true" v-model="queryDataComp.end" :disabled="!queryDataComp.start" class="form-control input-text" >{{endDateMobileComp}}</label>
                                <!--<input v-model="queryDataComp.end" class="form-control input-text" readonly="true" placeholder="Drop off" :disabled="!queryDataComp.start" />-->
                                <span class="input-group-addon">
                          <span class="fa fa-calendar"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-location">
                       
                        <div v-show="queryDataComp.serviceType!=6" class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="homeTypesList" name="serviceSelect" class="form-control " v-model="queryDataComp.homeType">
                                  <option value="null" disabled selected hidden>Social Preference</option>
                                  <option v-for="home in homeTypesList" v-bind:value="home.HomeType">
                                    {{home.HomeTypeName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                           
                    </div>

                         <div v-show="queryDataComp.serviceType==6" class="form-location">
                        <hr>
                        <p style="margin-left:10px;">Dog walking for specific days</p>
                            <label style="margin-left:10px;" class="small checkbox-inline" >
                                <input  type="checkbox"  v-model="sun" true-value=1  false-value=0><span class="small">Sun</span>
                            </label>
                            <label class="small checkbox-inline" >
                                <input type="checkbox"  v-model="mon" true-value=2  false-value=0><span class="small">Mon</span>
                            </label>
                                    
                            <label class="small checkbox-inline" >
                                <input type="checkbox"  v-model="tue" true-value=4  false-value=0><span class="small">Tue</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="wed" true-value=8  false-value=0><span class="small">Wed</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="thu" true-value=16  false-value=0><span class="small">Thu</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="fri" true-value=32  false-value=0><span class="small">Fri</span>
                            </label>
                                    
                            <label class="small checkbox-inline">
                                <input type="checkbox"  v-model="sat" true-value=64  false-value=0><span class="small">Sat</span>
                            </label>
                            <hr>
                     </div>
                     
                       <div v-show="queryDataComp.serviceType!=6" class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="petprefsList" name="petprefSelect" class="form-control " v-model="queryDataComp.petpref">
                                  <option value="null" disabled selected hidden>Pet Preference</option>
                                  <option v-for="pet in petprefsList" v-bind:value="pet.PetPref">
                                    {{pet.PetPrefName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                             <div class="form-location" v-if="(!filteredAreasList || filteredAreasList.length==0) && countryDataComp.CountryId!=9">
                            <div class='form-group'>
                                <select  class="form-control input-text">
                                      <option value="null" disabled selected hidden>{{selectAreaStatusComp}}</option>
                                </select>
                            </div>
                        
                        </div>
                    <div class="form-location" v-if="filteredAreasList && filteredAreasList.length>0">
                        <div class="form-group" v-if="filteredAreasList">
                            <div class='form-group ' v-if="filteredAreasList">
                       
                                <select  name="areaSelect" class="form-control input-text" v-model="queryDataComp.areaId">
                                    <option value="null" disabled selected hidden>Available Neighbors</option>
                                    <option v-for="area in filteredAreasList" v-bind:value="area.AreaId">
                                        {{area.AreaName}}
                                    </option>
                                </select>
                
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                      
                    <!-- <div class="form-group">
              
                        <select class="form-control input-text" placeholder="Filter on price" v-model="queryDataComp.priceRange">
                  <option v-for="price in priceList" v-bind:value="price.priceRange">
                    {{price.label}}
                  </option>
                </select>
              
                    </div>
                    <div role="group">
                        <a class="btn btn-default btn-block btn-sm"  v-model="queryDataComp.petpref" @click="updatePetPref(0)" v-bind:class="{active: queryDataComp.petpref==0}">
                            <img src="./Sitters/images/DogIcon.png" height="25"></img> <span class="button-text"> Dog Sitting</span> </a>

                        <a class="btn btn-default btn-block btn-sm"  v-model="queryDataComp.petpref" @click="updatePetPref(1)" v-bind:class="{active: queryDataComp.petpref==1}">
                            <img src="./Sitters/images/CatIcon.png" height="25"></img><span class="button-text"> Cat Sitting</span></a>

                        
                    </div> -->
                    <div style="margin-top:10px;">
                    <button  class="btn btn-warning btn-block btn-title" @click="resetFilters()">Reset Filters</button>
                    <button class="btn btn-info btn-block" @click="hideFilters()" data-toggle="collapse" data-target="#filters">
                        <i class="fa fa-minus-square-o"/>  Hide Filters
                    </button>
                    </div>
                    
                </div>
            </div>
            <div class="sortyByMobile hidden-md hidden-lg">
             <div style="margin-top:10px; margin-bottom:0px;">
                        <div class='form-group'>
                            <select id="sortingList" required v-if="sortingList"  name="sortSelect" class="form-control input-text" v-model="queryDataComp.sort">
                            <option value="null" disabled selected hidden>Select sorting option</option>
                            <option v-for="sortType in sortingList" v-bind:value="sortType.SortId">
                                {{sortType.SortName}}
                            </option>
                            </select>
                        </div>
                </div>
            </div>
            <div >
                <div v-if="loading" class="col-sm-8 pull-right hidden-xs hidden-sm">
                    <div class="text-center">
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                        </div>
                    </div>
                </div>

                  <div v-if="loading" class="hidden-md hidden-lg">
                    <div class="text-center">
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div  v-if="!loading" ref="sittersListDesktop">
            
            <div class="col-sm-8 pull-right hidden-xs hidden-sm"  v-if="sittersList && sittersList.length>0" v-for="(sitter, index) in sittersList"  >
                
                <div v-bind:class="{instagram: sitter.IsInstagramWinner}" class="card" :data-index="index" data-item="myname">
                <a :id="'user' + sitter.SitterId"  class="anchor"></a> 
                <div class="sitterListbox ">
                     <div v-if="sitter.IsActive" @click="premiumSwal()" style="cursor: pointer;" class="ribbon-container">
                        <a target="_blank">Premium <i class="fa fa-paw"/></a>
                    </div>
                    <div v-if="sitter.IsActive==false" @click="goSubscribe()" style="cursor: pointer;" class="ribbon-container-basic">
                       <a target="_blank">Basic</a>
                    </div>
                    <div class="profile-img">
                        <a :href="getHref(sitter)" target="_blank">
                        <img :src="sitter.ProfilePhotoUrl" alt=""  class="img-responsive img-rounded" style="cursor: pointer; min-width:170px; min-height:170px; border: 1px solid #c3c3c3;" height="240" width="240"></img>
                        
                         <div  style="cursor:pointer" v-if="sitter.IsOnline==true" class="rank-label-container">
                            <span class="label label-default rank-label" > Online</span>
                            
                        </div>
                        </a>
                    </div>
                    <div class="profile-body ">
                        <div class="profile-body-details">
                            <h2 >{{sitter.Name}} <span v-if="sitter.IsDogWalker" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Offers Dog Walking" style="display:inline;color:#78b5d2">&nbsp&nbsp <i class="fa fa-paw"/></span></h2> 
                              <figure style="display:inline-block; margin-left:15px;">
                               <strong> <p  class="small text-center" ><span class="small">From </span> <strong style="color: #feb34f;">{{sitter.Price}}</strong><span class="small" > {{currencyComp}}</span></p></strong>
                            </figure>
                            
                            <div class="home-details align-right">
                                <div v-if="sitter.IsInstagramWinner==true" style="margin-left:10px;" @click="instagramWinner(sitter)" class="pull-right">
                                        <i id="social-ig-f" class="fa fa-instagram fa-2x social"></i>
                                    </div>
                                <div class="homewrapper">
                                
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="resident cat at home" class="home-icons" v-if="sitter.IsHasCat">
                                        <span><img src="./Sitters/images/ResidentCat.png" height="25" width="25"></img></span>

                                    </div>
                                    
                                  
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="resident dog at home" class="home-icons" v-if="sitter.IsHasDog">
                                        <span><img src="./Sitters/images/ResidentDog.png" height="25" width="25"></img></span>

                                    </div>
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="children at home" class="home-icons" v-if="sitter.IsHasChildren">
                                        <span><img src="./Sitters/images/HasChildren.png" height="25" width="25"></img></span>

                                    </div>
                                    <div data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="smoking allowed at home" class="home-icons" v-if="!sitter.IsSmokeFree">
                                        <span><img src="./Sitters/images/Smoke.png" height="25" width="25"></img></span>

                                    </div>
                                    
                                </div>
                                  
                            </div>
                            <div>
                                
                                <span style="margin-top:2px;" class="fa fa-2x favorite" v-if="isFavorite(sitter.SitterId)==true" data-container="body" data-toggle="popover" data-trigger="hover" data-placement="top" data-content="Remove From Favorites" @click="addToFavorites(sitter)" lazy> 
                              <i  class="fa fa-heart"/>
                            </span>

                                <span style="margin-top:2px;"  class="fa fa-2x favorite" v-else data-toggle="popover" data-trigger="hover" data-container="body" data-placement="top" data-content="Add to Favorites" @click="addToFavorites(sitter)" lazy> 
                              <i  class="fa fa-heart-o"/>
                            </span>
                            </div>
                        </div>
                        <div class="bottom-row">
                            <div class="content">
                                <div v-if="sitter.RatingAvg">
                                    <i class="fa fa-star fa-1x inline" style="color:#ffd118; font-size:18px" v-for="n in sitter.RatingAvg" />
                                    <h6 class="text-muted inline reviews small"> &nbsp {{sitter.RatingCount}} {{reviewString(sitter.RatingCount)}}</h6>
                               
                                </div>
                                <h6 style="padding-top:2px;margin-top:0px;"  class="text-muted"> <i class="fa fa-map-marker"></i> {{sitter.Location}}</h6> 
                                   
                                <h4 style="padding-top:0px;margin-top:0px;">{{sitter.Title}}</h4>
                                
                                      
                                
                                <p class="text-overflow"> {{sitter.AboutMe}}</p>
                                 
                            </div>
                            
                        </div>
                         
                      
                            
                    </div>
                    
                </div>
                  <div style="color:green;padding-left:10px;padding-right:10px;" class="text-center">
                            <hr style="margin:5px;">
                                 <figure v-if="sitter.IsOnline==false && sitter.LastSeenOnline!=null" style="margin:5px; margin-left:0px;margin-left:0px;margin-right:10px" class="performance">
                            <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Last seen online: <strong>{{lastSeenDate(sitter.LastSeenOnline)}} </strong></figcaption>
                             
                           </figure>
                            <figure v-if="sitter.ResponseRate!=0" style="margin:5px; margin-left:0px;margin-left:0px;margin-right:10px" class="performance">
                            <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Response rate: <strong>{{sitter.ResponseRate}}% </strong></figcaption>
                             
                            </figure>

                             <figure style="margin:5px; margin-left:0px;;" v-if="!sitter.AverageResponseTime==0" class="performance">

                             <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Avg Response: <strong>{{sitter.AverageResponseTime}} </strong></figcaption>
                             
                            </figure>

                             <figure style="margin:5px; margin-left:0px;;" v-if="!sitter.RepeatedStays==0" class="performance">
                             <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Repeated client: <strong>{{sitter.RepeatedStays}} {{timeString(sitter.RepeatedStays)}}</strong></figcaption>
                            
                            </figure>
                            <div style="margin-bottom:10px;"></div>
                            
                            
                            
                        </div>
                      
                    <button @click="viewProfile(sitter)" target="_blank" style="margin-top:10px;" class="btn-block btn btn-success btn-title ">Visit Profile</button>
                        
            </div> <!--card end-->
            </div> <!--sitter col-sm-8 end-->
            
            
            </div>
            <div v-if="!loading && paginationComp.TotalPages>1" class="col-sm-8 pull-right hidden-xs hidden-sm">
               <div class="text-center">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                            <li v-for="item in totalPagesComp" @click="updatePage(item)" class="page-item" v-bind:class="{'active':isCurrentItem(item) }" ><a class="page-link" href="#">{{item}}</a></li>
                        </ul>
                        </nav>
                </div>
            </div>
            <div class="col-sm-8 pull-right hidden-xs hidden-sm"  v-if="sittersList && sittersList.length==0">
                <div  v-if="!loading" class="alert alert-info alert-dismissible" role="alert">
                    <h5>Sorry no sitters were found for your exact search, would you like to <a @click="resetFilters()" href="javascript:;"><strong>Reset Filters</strong></a> and try again?</h5>
                    <div v-if="filteredAreasList && filteredAreasList.length>0">
                    <hr>
                     <h5>Note: The following areas have available sitters that match your preferences, click on any area to view profiles:</h5>
                      <div v-for="area in filteredAreasList">
                        <a href="javascript:;" @click="changeArea(area)">{{area.AreaName}}</a>
                      </div>
                    </div>
                </div>
            </div>
            
            <div v-if="!loading">
            <div  class="col-xs-12 hidden-md hidden-lg"  style="padding:0px; margin:0px;" v-if="sittersList && sittersList.length>0" v-for="(sitter, index) in sittersList">
               <a :id="'smuser' + sitter.SitterId"  class="anchor"></a>        
                <div class="sittersListMobile">
                     
                    <div v-if="sitter.IsActive" @click="premiumSwal()" style="cursor: pointer;" class="ribbon">Premium <i class="fa fa-paw"/></div>
                    <div v-if="sitter.IsActive==false" @click="goSubscribe()" style="cursor: pointer;" class="ribbon-basic">Basic</div>
                <div v-bind:class="{instagram: sitter.IsInstagramWinner}" class="small-border">
                   <div  class="media-body">
                        
                        
                        <div v-if="sitter.IsInstagramWinner==true" class="pull-right" @click="instagramWinner(sitter)">
                            <i id="social-ig-f" class="fa fa-instagram fa-2x social"></i>
                                
                        </div>
                      <div class="media-left">
                            <img :src="sitter.ProfilePhotoUrl" alt="" @click="viewProfile(sitter)" class="media-object img-responsive img-rounded" style="min-width:60px; min-height:60px; border: 1px solid #c3c3c3;" height="80" width="80"></img>
                            <div  @click="viewProfile(sitter)" style="cursor:pointer" v-if="sitter.IsOnline==true" class="rank-label-container">
                                <span class="label label-default rank-label" > Online</span>
                            </div>
                            
                      </div>
                      <div class="media-left head-title">
                        <h4  style="display:inline;padding-bottom:0px;margin-bottom:0px;margin-top:0px;"><strong>{{sitter.Name}} </strong><h4 v-if="sitter.IsDogWalker" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Offers Dog Walking"  style="display:inline;padding-top:0px;margin-top:0px;color:#78b5d2">&nbsp&nbsp <i class="fa fa-paw"/></h4></h4>
                        <div v-if="sitter.RatingAvg">
                                    <i class="fa fa-star fa-1x inline" style="margin:0px;color:#ffd118; font-size:15px" v-for="n in sitter.RatingAvg" />
                                    <h5 style="padding:0px;margin:0px;font-size:15px" class="text-muted inline reviews"> &nbsp {{sitter.RatingCount}} {{reviewString(sitter.RatingCount)}}</h5>
                        </div>
                        <h6 style="padding-top:2px;margin-top:2px" class="text-muted"> <i class="fa fa-map-marker"></i> {{sitter.Location}}</h6>
                    </div>
                    
                    <h4 style="padding-top:5px;margin-top:5px;padding-bottom:2px;margin-bottom:2px;">{{sitter.Title}}</h4>
                    
                    <p class="text-overflow"> {{sitter.AboutMe}}</p>
                    <div style="color:green;">
                            <hr style="margin:5px;">
                            <figure v-if="sitter.IsOnline==false && sitter.LastSeenOnline!=null" style="margin:5px; margin-left:2px;margin-right:10px" class="performance">
                            <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Last seen: <strong>{{lastSeenDate(sitter.LastSeenOnline)}}  </strong></figcaption>
                             
                            </figure>

                            <figure v-if="sitter.ResponseRate!=0" style="margin:5px; margin-left:0px;margin-left:0px;margin-right:10px" class="performance">
                            <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Response rate: <strong>{{sitter.ResponseRate}}%</strong></figcaption>
                             
                            </figure>
                             <figure style="margin:5px; margin-left:2px;;" v-if="!sitter.AverageResponseTime==0" class="performance">
                             <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Avg Response: <strong>{{sitter.AverageResponseTime}} </strong></figcaption>
                             
                            </figure>

                             <figure style="margin:5px; margin-left:2px;;" v-if="!sitter.RepeatedStays==0" class="performance">
                             <figcaption class="h6 small" style="margin-top:0px;margin-bottom:0px;margin-left:0px;margin-right:10px">Repeated client: <strong>{{sitter.RepeatedStays}} {{timeString(sitter.RepeatedStays)}}</strong></figcaption>
                            
                            </figure>
                            <div style="margin-bottom:10px;"></div>
                            
                        </div>
                    <div class="col-xs-9" style="padding-left:0px;margin-left:0px;">
                
                    <button @click="viewProfile(sitter)" class="btn btn-success btn-block btn-title">Visit Profile</button>
                    <button v-if="isFavorite(sitter.SitterId)==true" @click="addToFavorites(sitter)" lazy class="btn btn-info btn-block btn-title">Added to favorites <i class="fa fa-heart"/></button>
                    <button v-else @click="addToFavorites(sitter)" lazy class="btn btn-info btn-block btn-title">Add to favorites <i style="color:white" class="fa fa-heart-o"/></button>
                    
                     
                    </div>
                    <div class="col-xs-3 price-wrap">
                        <div class="pricing-head-mobile">
                            <h4><span>from</span>{{sitter.Price}}<span>{{currencyComp}}/day</span></h4>
                        </div>
                    </div>
                  </div>
                </div>
                <br>
                </div>
            
            </div> <!--col-xs-12 hidden-md-->
            <div class="col-xs-12  hidden-md hidden-lg " v-if="!loading && paginationComp.TotalPages>1">
               <div class="text-center">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                            <li v-for="item in totalPagesComp" @click="updatePage(item)" class="page-item" v-bind:class="{'active':isCurrentItem(item) }" ><a class="page-link" href="#">{{item}}</a></li>
                        </ul>
                        </nav>
                </div>
            </div>
            </div> <!--end of pagination-->
          
            <div class="col-xs-12  hidden-md hidden-lg  remove-margins"  v-if="sittersList && sittersList.length==0">
                <div v-if="!loading" class="alert alert-info alert-dismissible" role="alert">
                <h5>Sorry no sitters were found for your search criteria, would you like to <a @click="resetFilters()" href="javascript:;">Reset Filters</a> and try again?</h5>
                   <div v-if="filteredAreasList && filteredAreasList.length>0">
                    <hr>
                     <h5>Note: The following areas have available sitters that match your preferences, click on any area to view profiles:</h5>
                      <div v-for="area in filteredAreasList">
                        <a href="javascript:;" @click="changeArea(area)">{{area.AreaName}}</a>
                      </div>
                    </div>
                </div>
            </div>
            
        </div>
        
    </div>
    
</div>
</template>
<script>
 



import auth from '../auth/index'
import store from '../data/store'
import commonApi from '../services/commonApi'
import customerApi from '../services/customerApi'


export default {
  
 data() {
    return {
      loading: false,
      error: '',
      alert: '',
      emailConfirmed: true,
          days: 0,
            sun: 0,
            mon: 0,
            tue: 0,
            wed: 0,
            thu:0,
            fri:0,
            sat:0,
      sortingList: [
          {SortId: 0, SortName: 'Sort by Recommended'},
          {SortId: 4, SortName: 'Fastest Response'},
          {SortId: 3, SortName: 'Highest Reviews'},
          {SortId: 1, SortName: 'Lowest Price'},
          {SortId: 2, SortName: 'Highest Price'}
          
      ],
      servicesList: [
          {ServiceType: 1, ServiceName:'Dog Boarding (Sitter Home)'},
          {ServiceType: 2, ServiceName:'Cat Boarding (Sitter Home)'},
          {ServiceType: 3, ServiceName:'Dog Sitting (Your Home)'},
          {ServiceType: 4, ServiceName:'Cat Sitting (Your Home)'},
          {ServiceType: 5, ServiceName:'Pick up and Delivery'},
          {ServiceType: 6, ServiceName:'Dog Walking'}
      ],
      homeTypesList: [
          {HomeType: 0, HomeTypeName:'Show All'},
          {HomeType: 1, HomeTypeName:'Resident Dog at home'},
          {HomeType: 2, HomeTypeName:'Resident Cat at home'},
          {HomeType: 3, HomeTypeName:'Children at home'},
          {HomeType: 4, HomeTypeName:'None at home'},
      ],
      petprefsList: [
          {PetPref: 0, PetPrefName:'Show All'},
          {PetPref: 1, PetPrefName:'Accepts Small Dogs 0-7 KG'},
          {PetPref: 2, PetPrefName:'Accepts Medium Dogs 8-18 KG'},
          {PetPref: 3, PetPrefName:'Accepts Large Dogs 19+ KG'},
      ],
      title: "Pet Sitters Search",
      pending: true,
      priceList: [
        {label: 'Price Range (All prices)', priceRange: null},
        {label: 'From 50 to 99 aed',priceRange: 0},
        {label: 'From 100 to 149 aed',priceRange: 1},
        {label: 'From 150 to 200 aed',priceRange: 2},
        {label: 'From 199 to 250 aed',priceRange: 3},
      ]
    }
  },
  updated: function(){
      this.$ga.page(this.$router)
      var self = this;
      $('[data-toggle="popover"]').popover();

        // window.addEventListener('scroll', this.onScroll)
        // $zopim(function (){
        //     $zopim.livechat.sendVisitorPath();
          
    
        // });
        
    if (this.$route.hash){
        location.href = this.$route.hash;
    }
    

    if (this.$route.params.cityId!=null)
        self.queryDataComp.cityId=this.$route.params.cityId;

    
     const idToScrollTo = this.$router.currentRoute.hash;
    
    if (!self.loading && idToScrollTo) {
        console.log('entering')
        console.log($( window ).width())
        setTimeout(function(){
            var smallPage = '#sm' + idToScrollTo.substr(1)
            if (document.querySelector(smallPage) && $(window).width()<992)   
            {
                self.$scrollTo(smallPage)
            }
            else if (document.querySelector(idToScrollTo) && $(window).width()>991) {
                self.$scrollTo(idToScrollTo)
            }
        
         self.cleanAnchor()

        },10)  
    }
  
   

    
  },
  mounted: function () {
    var self = this;
    // this.queryDataComp.areaId = null;
    
    // store.dispatch('FilteredAreasList', null)
    self.loading = true
 
    commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                    
                }).fail(function (error){
                    swal("Oops", "Failed to get sitters list, please contact support for assistance","error")
                })  //get sitters data
   

    if (store.getters.authenticated) {
        if (localStorage.getItem('emailConfirmed') != null) {
        var check = localStorage.getItem('emailConfirmed')
        if (check == "False") {
          this.emailConfirmed = false
        }
      }
    }
    

  
    
    self.$nextTick(function() {
        var self = this

              
         
       $('#findSittersDatePickerToMobile').datepicker({
                autoclose: true,
                format: 'yyyy-mm-dd',
                todayHighlight: true,
                beforeShowDay: function(date) {
                       if (!self.queryDataComp.start){
                        return date.valueOf() >= new Date();
                        } else {
                          return date.valueOf() >= moment(self.queryDataComp.start)
                      }
                  
                },
    }).on('changeDate', function (selected){   //When changing date..
            self.queryDataComp.end =  moment(selected.date).format('YYYY-MM-DD')                
    });


    $('#findSittersDatePickerFromMobile').datepicker({
            autoclose: true,
            format: 'yyyy-mm-dd',
            todayHighlight: true,
            beforeShowDay: function(date) {
                return moment(date).add(1,"days") >= moment();
                
    },
    }).on('changeDate', function (selected){  //When changing date..
                        self.queryDataComp.start =  moment(selected.date).format('YYYY-MM-DD')
                        if (!self.queryDataComp.end){   //Fill end date to start date if it's empty only                        
                          $('#findSittersDatePickerToMobile').datepicker('update', self.queryDataComp.start)
                          self.queryDataComp.end = self.queryDataComp.start

                        } else if (self.queryDataComp.end<self.queryDataComp.start){
                          
                          $('#findSittersDatePickerToMobile').datepicker('update', self.queryDataComp.start)
                          self.queryDataComp.end = self.queryDataComp.start
                          
                        } else {  //This step is needed if customer goes back in date on findSittersDatePickerFrom to allow for beforeShowDay refresh.
                           $('#findSittersDatePickerToMobile').datepicker('destroy')
                           $('#findSittersDatePickerToMobile').datepicker({
                                        autoclose: true,
                                        format: 'yyyy-mm-dd',
                                        todayHighlight: true,
                                        beforeShowDay: function(date) {
                                                  return date.valueOf() >= moment(self.queryDataComp.start)
                                                 }
                                        }).on('changeDate', function (selected){   //When changing date..
                                          self.queryDataComp.end =  moment(selected.date).format('YYYY-MM-DD')                
                            });
                        }
    }); //end of findSittersDatePickFrom/To Mobile

      $('#findSittersDatePickerTo').datepicker({
                autoclose: true,
                format: 'yyyy-mm-dd',
                todayHighlight: true,
                beforeShowDay: function(date) {
                       if (!self.queryDataComp.start){
                        return date.valueOf() >= new Date();
                        } else {
                          return date.valueOf() >= moment(self.queryDataComp.start)
                      }
                  
                },
    }).on('changeDate', function (selected){   //When changing date..
            self.queryDataComp.end =  moment(selected.date).format('YYYY-MM-DD')                
    });


    $('#findSittersDatePickerFrom').datepicker({
            autoclose: true,
            format: 'yyyy-mm-dd',
            todayHighlight: true,
            beforeShowDay: function(date) {
                return moment(date).add(1,"days") >= moment();
                
    },
    }).on('changeDate', function (selected){  //When changing date..
                        self.queryDataComp.start =  moment(selected.date).format('YYYY-MM-DD')
                        if (!self.queryDataComp.end){   //Fill end date to start date if it's empty only                        
                          $('#findSittersDatePickerTo').datepicker('update', self.queryDataComp.start)
                          self.queryDataComp.end = self.queryDataComp.start

                        } else if (self.queryDataComp.end<self.queryDataComp.start){
                          
                          $('#findSittersDatePickerTo').datepicker('update', self.queryDataComp.start)
                          self.queryDataComp.end = self.queryDataComp.start
                          
                        } else {  //This step is needed if customer goes back in date on findSittersDatePickerFrom to allow for beforeShowDay refresh.
                           $('#findSittersDatePickerTo').datepicker('destroy')
                           $('#findSittersDatePickerTo').datepicker({
                                        autoclose: true,
                                        format: 'yyyy-mm-dd',
                                        todayHighlight: true,
                                        beforeShowDay: function(date) {
                                                  return date.valueOf() >= moment(self.queryDataComp.start)
                                                 }
                                        }).on('changeDate', function (selected){   //When changing date..
                                          self.queryDataComp.end =  moment(selected.date).format('YYYY-MM-DD')                
                            });
                        }
    });
  });  // end of nextTick!
   


    
  },
  methods: {
    cleanAnchor: function(){
        this.$router.replace({path:'/findsitters'}) //used to remove anchor#sitterId and not flicker when using filters.
        // console.log(this.$router.currentRoute)
        // console.log(this.$router)
    },
    getHref: function(sitter){
        return 'https://www.dupaws.com/sitter/' + sitter.SitterId
    },
    goSubscribe: function(){
        swal({
                title: "Basic Account",
                text: "Basic account is a free membership access to pet sitters, if you want to book a basic account user, you will need to have an active subscription.",
                type: "info",
                showCancelButton: true,
                confirmButtonClass: 'btn-success',
                confirmButtonText: "Subscribe",
                closeOnConfirm: true,
                html: true
              }, function(){
                self.$router.push({path: '/subscribe'})
              });
    },
    lastSeenDate: function(lastSeenDate){
        return moment(lastSeenDate).fromNow()
    },
    premiumSwal: function(){
            swal({
                            title: 'Premium Member',
                            text: "You can contact and book Premium accounts directly without subscription or membership.",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            
                            });
     },
     gaClick: function(){
         var self = this
         
     },
      reviewString: function(count){
            if (count==1)
                return 'Review'
            else 
                return 'Reviews'
        
          },
      timeString: function(count){
            if (count==1)
                return 'time'
            else 
                return 'times'
        
          },

    
     sortList: function(value){
          var self = this
           self.loading = true
               self.$ga.event('Sort filter changed', 'Action')
           self.queryDataComp.sort = value
           this.queryDataComp.currentPage = 0;
           commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
      },
      changeArea(area){
          this.queryDataComp.areaId=parseInt(area.AreaId)
          this.loading = true
          self.$ga.event('Area Changed', 'Action', 'AreaId', area.AreaId)
          commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
      },
      isCurrentSort(value){
        if (this.queryDataComp.sort==value)
            return true
        else
            return false
      },
      isCurrentItem(page){
          if (this.paginationComp.CurrentPage==page)
            return true
          else 
            return false
      },
      goAccount(){
            this.$router.push({path: '/account', force: true})
        },
      hideFilters(){
            this.$SmoothScroll(0, 200)
      },
      resetFilters() {
        var self = this
        self.$router.push({path: '/findsitters'})
        store.commit('clearFilters')
        self.$ga.event('Filters Cleared', 'Action', 'Cleared Filters')
        commonApi.getCitiesList(store.getters.CountryData.CountryId, 0)
        commonApi.getSittersList(store.getters.QueryData)
       
      },
      addToFavorites: function(sitter) {
           self = this;
           self.cleanAnchor()
          if (store.getters.authenticated==false)
            swal({
              title: "Hello",
              text: "You need to be logged in as a Customer to add sitters to your favorite account",
              type: "info",
              showCancelButton: true,
              confirmButtonClass: 'btn-success',
              confirmButtonText: "Login",
              closeOnConfirm: true,
              html: true
            }, function(){
              self.$router.push({path: '/login', query: {redirect: 'findSitters'}})
            });
            else if (self.userRoleComp=="Sitter"){
               swal("Hello",'You cant add Sitters as favorites while logged in as a Sitter, please switch to Customer login then try again' ,"info");
            }
            else {
              customerApi.addSitterToFavorites(sitter)
            }
          
      },
      instagramWinner: function(sitter){
          swal("Dupaws Instagram Photo Winner", sitter.Name + "Is the latest Dupaws Instagram contest winner", "success")
      },
      viewProfile: function(sitter){
        this.$router.push('#user' + sitter.SitterId) //for history mode if users click back on the browser
        this.$router.push({path:'/sitter/' + sitter.SitterId})
      },
      goHome: function(){
          this.$router.push({path: '/'})
      },
      updatePage: function(page){
          var self = this
           self.loading = true
           self.queryDataComp.currentPage = page
           self.$ga.event('Pagination clicked', 'Action', 'Page Number', page)
           commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
      },
      updatePetPref: function(PetPref){
      this.queryDataComp.PetPref=parseInt(PetPref)
    },
    isFavorite: function(sitterId){   //Needs improvement, calling many times.
       if (this.userRoleComp=="Sitter")   //sitters cannot add another sitter, they need to login as clients
            return false
       var result = $.grep(store.getters.FavoriteSitters, function(e){ return e.SitterId == sitterId })
       if (result.length>0)
          return true
       else
        return false
     }
  },   
  watch:{
        'queryDataComp.sort': function(sortId){
            if (sortId!=null){
                this.cleanAnchor()
                this.sortList(sortId)
            }
        },
        'queryDataComp.cityId': function(cityId){
          var self = this
         
          this.queryDataComp.currentPage = 0;
          this.queryDataComp.areaId = null;
          store.dispatch('FilteredAreasList', null)
          if (store.getters.QueryData.cityId!=null){
            self.loading = true
            self.$ga.event('City Changed', 'Action', 'CityId', store.getters.QueryData.cityId)
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
            }
         
        },
        'queryDataComp.areaId': function(){
            var self = this
            this.queryDataComp.currentPage = 0;
          if (store.getters.QueryData.areaId!=null)
          {
           self.loading = true
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
         }
        },
        'dogWalkingDaysComp': function(){
            var self = this
            this.queryDataComp.currentPage = 0;
            store.getters.QueryData.dogwalkingdays = self.dogWalkingDaysComp
            if (store.getters.QueryData.dogwalkingdays!=null)
          {
           self.loading = true
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                self.$ga.event('Dogwalking Days Changed', 'Action', 'Days Per Week', store.getters.QueryData.dogwalkingdays)
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
         }
        },
        'queryDataComp.serviceType': function(){
            var self = this
            this.queryDataComp.currentPage = 0;
          if (store.getters.QueryData.serviceType!=null)
          {
           self.loading = true
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                self.$ga.event('ServiceType Changed', 'Action', 'ServiceId', store.getters.QueryData.serviceType)
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
         }
        },
        'queryDataComp.homeType': function(){
            var self = this
            this.queryDataComp.currentPage = 0;
          if (store.getters.QueryData.homeType!=null)
          {
           self.$ga.event('HomeType Changed', 'Action', 'HomeTypeId', store.getters.QueryData.homeType)
           self.loading = true
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
         }
        },
        'queryDataComp.petpref': function(){
            var self = this
            console.log('changed')
            this.queryDataComp.currentPage = 0;
          if (store.getters.QueryData.petpref!=null)
          {
            
           self.loading = true
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
         }
        },
        'queryDataComp.start': function(){
            var self = this
          if (store.getters.QueryData.start!=null)
          {
            self.$ga.event('Date Range changed', 'Action', 'StartDate Changed')
            self.loading = true
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
            }
        

        },
        'queryDataComp.end': function(){
            var self = this
          if (store.getters.QueryData.end!=null)
          {
            self.loading = true
            self.$ga.event('Data Range changed', 'Action', 'EndDate Changed')
            commonApi.getSittersList(store.getters.QueryData).then(function(data){
                    self.loading = false
                }).fail(function (error){
                    console.log(error)
                })
                }
        
        },
   },
   head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title
      }
    },
    meta: [
      { name: 'application-name', content: 'Dupaws.com Pet Sitting' },
      { name: 'description', content: 'Find the Perfect Pet Sitter, Cat and Dog boarding at homes.', id: 'desc' },
      { property: 'fb:app_id', content: '279352372578608' },
      { property: 'og:title', content: 'Find a loving home for your pets' },
      { property: 'og:url', content: 'https://www.dupaws.com/findsitters' },
      { property: 'og:type', content: 'website' },
      { property: 'fb:admins', content:'636428053' },
      { property: 'fb:pages', content:'1623158747696830' },
    ],
     link: [
      { rel: 'canonical', href: 'https://www.dupaws.com/findsitters', id: 'canonical' },
     ]
  },
  computed: {
      dogWalkingDaysComp: function(){
          return  this.sun | this.mon | this.tue | this.wed | this.thu | this.fri | this.sat
      },
      startDateMobileComp: function(){
          if (this.queryDataComp.start==null){
              return 'Pick up date'
          } else
              return this.queryDataComp.start
      },
      endDateMobileComp: function(){
          if (this.queryDataComp.end==null){
              return 'Drop off date'
          } else 
            return this.queryDataComp.end
      },
      selectCityStatusComp: function(){
          if (store.getters.CountryData.CountryId!=9)
            return 'Select a City'
          if (store.getters.CountryData.CountryId==9)
            return 'Select your Area'
      },
      selectAreaStatusComp: function(){ //workaround for singapore
          if (store.getters.CountryData.CountryId!=9)
            return 'Select City to filter neighbors'
          if (store.getters.CountryData.CountryId==9)
            return 'Select Area to see available neighbors'
      },
    totalPagesComp: function(){
        return Math.min(this.paginationComp.TotalPages, 9)
    },
    currencyComp: function(){
        return store.getters.CountryData.Currency
    },
    errorMsg: function () {
      return this.error
    },
    alertMsg: function () {
      return this.alert
    },
    sittersList: function(){
        return store.getters.SittersList.SitterDtos
    },
    paginationComp: function(){
        return store.getters.SittersList
    },
    timezoneComp: function(){
        return store.getters.CountryData.CountryTimezone
    },
    queryDataComp: function(){
       return store.getters.QueryData;
       
     },
     citiesList: function(){
            return store.getters.CitiesList
     },
     filteredAreasList: function(){
          return store.getters.FilteredAreasList
     },
     userRoleComp: function(){
       return store.getters.userRole
     },
     countryDataComp: function(){
         return store.getters.CountryData
     }
    
  },
  
}

 
</script>
<style scoped>


.btn-title{
  font-size:20px;
  font-family: 'Yanone Kaffeesatz', sans-serif;
}

.sittersListMobile{
    overflow: hidden; 
    position:relative;
}

.ribbon{
    width: 160px;
    height: 32px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
        background: linear-gradient(#e3a4fe 0%, #7a5a88 100%);
    transform: rotate(45deg);
    position: absolute;
    right: -42px;
    top: 20px;
    padding-top: 7px;
}

.ribbon-basic{
    width: 160px;
    height: 32px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
        background-color: #969696;
    transform: rotate(45deg);
    position: absolute;
    right: -42px;
    top: 20px;
    padding-top: 7px;
}


.performance{
    
    display: inline-block;
}


.price-wrap{
   border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    padding:5px;
}

.small-border{
   border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    padding: 10px;
    border-radius: 5px;
}


.rank-label-container {
    margin-top: -32px;
    
    /* z-index: 1000; */
    text-align: center;
}

.label.label-default.rank-label {
    background-color:rgb(92, 184, 92);
    padding: 5px 10px 5px 10px;
    border-radius: 27px;
}



.pricing-head-mobile h4 span {
  display: block;
  font-size: 14px;
  font-style: italic;
  color: grey;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding-left: 0px;
}

.pricing-head-mobile h4 {
font-size: 38px;
    font-weight: 300;
    border-radius: 5px;
    text-align: center;
    color: #feb34f;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding-left: 0px;
  
}


.filters{
  background-color:#e5e5e5;
  padding:20px;
  border-radius:5px;
  border-style:solid;
  border: 1px;
  border-color: red;
}

.button-text{
    
    color:#4d4c4c;
    right:auto;
    padding:10px;
    font-family: 'Yanone Kaffeesatz', sans-serif;
    
}


.btn-default {
    color: rgb(6, 11, 66);
    background-color: rgba(236, 247, 253, 0.43);
    border-color: #ccc;
    text-align:left;
}

.btn-default:active:hover, .btn-default.active:hover, .open > .dropdown-toggle.btn-default:hover, .btn-default:active:focus, .btn-default.active:focus, .open > .dropdown-toggle.btn-default:focus, .btn-default:active.focus, .btn-default.active.focus, .open > .dropdown-toggle.btn-default.focus {
    color: #333;
    background-color: #adc1d3;
    border-color: #adadad;
}

.btn-default:hover, .btn-default:hover, .open > .dropdown-toggle.btn-default:hover{
    color: #333;
    background-color: rgba(217, 237, 247, 0.91);
    border-color: #adadad;
}


.btn-default:active, .btn-default.active, .open > .dropdown-toggle.btn-default {
    color: #333;
    background-color: rgba(188, 203, 217, 0.58);
    border-color: #adadad;
}






.form-border{
    background-color: white;
    padding: 12px;
    border-radius: 5px;


}



.reviews {
    margin-bottom: 0px;
    vertical-align: bottom;
    font-size: medium;
    margin-left: 0px;

}


.align-right {
  margin-left: auto;
}

.sitterListbox {
  display:flex;
  flex-wrap: wrap;
  
}

.bottom-row {
  display: flex;
  justify-content: space-between
}

.sitterListbox .profile-img {
  flex: .5;
  height:170px;
  width:170px;
}

.sitterListbox .profile-body {
  flex: 3;
  padding-left: 10px;
  flex-wrap:wrap;
  
  
  
}


.sitterListbox .profile-body .profile-body-details{
  display:flex;
  flex-wrap: nowrap;
}

.sitterListbox .profile-body .profile-body-aboutme {
  display: flex;
  
}

.strong-font{
    font-weight:600!important;
}

.homewrapper{
    
    display: flex;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
    background-color: aliceblue;
    transition: 0.3s;
    border-radius: 8px;
    border-bottom-width: inherit;
}

.home-icons {
  padding:3px;
}

.sitterListbox .profile-body h2 {
  margin-top:0px;
  margin-bottom:0px;
}

.sitterListbox .profile-price {
  flex: 1;
  
}

.inline {
  display: inline;
  vertical-align: middle;
  padding-right: 1px;
  
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


.fa-heart-o {
  color:#848484; opacity: 0.7;
}

.instagram{
    background-color: rgba(228, 184, 255, 0.21);
}

.favorite {
    color:#af1818; opacity: 0.7;
    padding-left:10px;
    
}

.favorite:hover {
    opacity: 1;
}

.favorite:active {
    transform: scale(1.1);
}

.card {
    /* Add shadows to create the "card" effect */
    margin-bottom: 20px;
    transition: 0.3s;
    border:1px;
    padding:10px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
    
}


/* On mouse-over, add a deeper shadow */
.card:hover {
    box-shadow: 0 10px 16px 0 rgba(1,0,0,0.2);
    background:  aliceblue;
    opacity: 1;
    
}
    
/* Add some padding inside the card container */
#social-ig-f {
     color: #974250;
 }

 	.ribbon-container {
				position: absolute;
				top: 55px;
				right: 0px;
				overflow: visible; /* so we can see the pseudo-elements we're going to add to the anchor */
				font-size: 14px; /* font-size and line-height must be equal so we can account for the height of the banner */
				line-height: 14px;
                border-radius: 1px;
			}
			
	
	
			
	.ribbon-container a {
				display:block;
				padding:10px;
				position:relative; /* allows us to position our pseudo-elements properly */
				    background: linear-gradient(#e3a4fe 0%, #7a5a88 100%);
                    border-top-right-radius: 10px 10px;
                    border-bottom-left-radius: 10px 10px;

				overflow:visible;
				height:38px;
				margin-left:29px;
				color:#fff;
				text-decoration:none;
			}
			
	.ribbon-container a:after { /* this creates the "folded" part of our ribbon */
				content:""; 
				height: 0;
				width: 0;
				display:block;
				position:absolute;
				bottom:-15px;
				right:0;
				border-top: 15px solid #905AA7; 
				border-right: 15px solid transparent;
			}
			
		.ribbon-container-basic {
				position: absolute;
				top: 55px;
				right: 0px;
				overflow: visible; /* so we can see the pseudo-elements we're going to add to the anchor */
				font-size: 14px; /* font-size and line-height must be equal so we can account for the height of the banner */
				line-height: 14px;
                border-radius: 1px;
			}
			
	
	
			
	.ribbon-container-basic a {
				display:block;
				padding:10px;
				position:relative; /* allows us to position our pseudo-elements properly */
				    background-color: #969696;
                    border-top-right-radius: 10px 10px;
                    border-bottom-left-radius: 10px 10px;

				overflow:visible;
				height:38px;
				margin-left:29px;
				color:#fff;
				text-decoration:none;
			}
			
	.ribbon-container-basic a:after { /* this creates the "folded" part of our ribbon */
				content:""; 
				height: 0;
				width: 0;
				display:block;
				position:absolute;
				bottom:-15px;
				right:0;
				border-top: 15px solid #969696; 
				border-right: 15px solid transparent;
			}
			
	
a.anchor {
    display: block;
    position: relative;
    top: -100px;
    visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// FindSitters.vue?45be4e4e